import { FormattedMessage, useIntl } from 'react-intl';
import React, { useContext } from 'react';
import { useModal } from 'store/modals';
import { DeleteButton } from '../../../../../../../../../form-elements/buttons/DeleteButton';
import { useDeleteUser } from '../../../../../../../../../../services/admin/delete-user';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';

export const DeleteUser = () => {
  const intl = useIntl();
  const { openModal } = useModal();
  const { selectedUser, setSelectedUser } = useContext(UserAdministrationModalContext);

  const { deleteUserAsync } = useDeleteUser({
    onSuccess: () => {
      setSelectedUser(null);
    },
  });

  function onDeleteUser() {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage({
          id: 'removeUser',
        }),
        content: intl.formatMessage({
          id: 'deleteUserWarning',
        }),
        onConfirm: () => deleteUserAsync(selectedUser.id),
      },
    });
  }

  return (
    <DeleteButton
      intl="deleteUserPermanently"
      onClick={() => onDeleteUser()}
    >
      <FormattedMessage id="deleteUserPermanently" />
    </DeleteButton>
  );
};
